import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';
import { StorageService } from '../../shared/services/storage.service';

@Directive({
  selector: '[smoothScrollSidebar]',
  exportAs: 'smoothScrollSidebar',
})
export class SmoothScrollSidebarDirective implements AfterViewInit {
  private scrollTarget = 0;
  private animationFrame: number | null = null;
  private startY = 0;
  constructor(
    private readonly el: ElementRef,
    private readonly _storage: StorageService,
  ) {}

  ngAfterViewInit() {
    if (!this._storage.getBrowser()) return;

    const el = this.el.nativeElement as HTMLElement;
    this.scrollTarget = el.scrollTop;
  }

  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    if (!this._storage.getBrowser()) return;

    event.preventDefault();
    const el = this.el.nativeElement as HTMLElement;

    this.scrollTarget += event.deltaY;
    this.scrollTarget = Math.max(0, Math.min(this.scrollTarget, el.scrollHeight - el.clientHeight));

    if (!this.animationFrame) {
      this.animateScroll();
    }
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    if (!this._storage.getBrowser()) return;
    this.startY = event.touches[0].clientY;
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    if (!this._storage.getBrowser()) return;

    event.preventDefault();
    const el = this.el.nativeElement as HTMLElement;

    const deltaY = this.startY - event.touches[0].clientY;
    this.startY = event.touches[0].clientY;

    this.scrollTarget += deltaY;
    this.scrollTarget = Math.max(0, Math.min(this.scrollTarget, el.scrollHeight - el.clientHeight));

    if (!this.animationFrame) {
      this.animateScroll();
    }
  }

  private animateScroll() {
    if (!this._storage.getBrowser()) return;

    const el = this.el.nativeElement as HTMLElement;
    const diff = this.scrollTarget - el.scrollTop;

    // Use bigger factor for mobile (touch)
    const speedFactor = this.isTouchDevice() ? 0.3 : 0.15;

    el.scrollTop += diff * speedFactor;

    if (Math.abs(diff) > 0.5) {
      this.animationFrame = requestAnimationFrame(() => this.animateScroll());
    } else {
      this.animationFrame = null;
    }
  }

  public scrollToBottom() {
    if (!this.el?.nativeElement) return;
    if (!this._storage.getBrowser()) return;

    const el = this.el.nativeElement as HTMLElement;
    this.scrollTarget = el.scrollHeight - el.clientHeight;

    if (!this.animationFrame) {
      this.animateScroll();
    }
  }

  // Helper to detect touch device
  private isTouchDevice(): boolean {
    return 'ontouchstart' in this._storage.getWindow() || navigator.maxTouchPoints > 0;
  }
}
